import axiosInstance from '../lib/axiosInstance';

export const fetchSectionAttribute = sectionAttributeId => {
  return axiosInstance.get(`/admin/section-attributes/${sectionAttributeId}/detail`);
};

export const updateSectionAttribute = (sectionAttributeId, params) => {
  return axiosInstance.put(`/admin/section-attributes/${sectionAttributeId}`, params);
};